import classNames from 'classnames';
import React from 'react';
import {typeConvertor} from './utilities';
import useDeleteAd from 'modules/myAdvertisment/myAdvertisment/deleteModal/deleteForm/hooks/useDeleteAd';
import useSaledPost from 'modules/myAdvertisment/hooks/useSaledPost';
import { useLocation, useNavigate } from 'react-router-dom';
interface EndTimeWarningProps {
  app: 'farm' | 'wholesaler';
  title: string;
  type: string;
  guid: string;

  chosedSugestionUser: IChosedSugestionUser;
  setisOpenEndModal: (isOpenEndModal: boolean) => void;
  setChosedSugestionUser: (chosedSugestionUser: IChosedSugestionUser) => void;
}
const EndTimeWarning = ({
  app,
  title,
  type,
  guid,
  setisOpenEndModal,
  chosedSugestionUser,
  setChosedSugestionUser,
}: EndTimeWarningProps) => {
  const location = useLocation();
  const navigate = useNavigate();

  const isFarm = location.pathname.includes('farm');
  const {mutate} = useDeleteAd({
    isNavigate: true,
    action: () => setisOpenEndModal(false),
  });

  const {mutateSaled} = useSaledPost({});
  const sellButtonHandler = () => {
    if (type === 'sale') {
      mutateSaled({guid: guid});
    } else {
      setisOpenEndModal(false);
      setChosedSugestionUser({
        isOpenModal: true,
        type: type,
        profile: null,
        guid: guid,
        isDelete: false,
      });
    }
  };
  return (
    <div className="relative bg-white w-[90%] flex flex-col rounded-lg p-4">
      <div className="flex flex-col w-full justify-center items-center gap-4">
        <div
          className={classNames(' bg-white p-4 rounded-full', {
            'absolute top-[-45px]  border-2 border-primary ':
              app === 'wholesaler' ? true : false,
          })}
        >
          <span className="icon-error text-error text-[50px]" />
        </div>
        <h4
          className={classNames('text-gray-5 font-medium text-18px', {
            'mt-16 mb-8': app === 'wholesaler' ? true : false,
          })}
        >
          زمان {typeConvertor[type]} {title} به پایان رسید
        </h4>
      </div>
      <div className="flex flex-col w-full gap-4">
        {(type === 'sale' || type === 'auction') && (
          <button
            className=" text-center w-full py-3 bg-white border border-primary rounded-md text-primary"
            onClick={sellButtonHandler}
          >
            محصول فروخته شد
          </button>
        )}
        {type === 'prepayment' && (
          <button
            className=" text-center w-full py-3 bg-white border border-primary rounded-md text-primary"
            onClick={() => {
              setisOpenEndModal(false);

              setChosedSugestionUser({
                isOpenModal: true,
                type: type,
                profile: null,
                guid: guid,
                isDelete: false,
              });
            }}
          >
            سرمایه گذار انتخاب شد
          </button>
        )}
        <button
          className=" text-center w-full py-3 bg-white border border-primary rounded-md text-primary"
          onClick={() =>
            navigate(`/${isFarm ? 'farm' : 'wholesaler'}/edit/info/${guid}`)
          }
        >
          انتشار مجدد آگهی
        </button>
        <button
          className=" text-center w-full py-3 bg-white border border-primary rounded-md text-primary"
          onClick={() =>
            mutate({delete_reason: 'unsuccessful', guid: guid, type: 'post'})
          }
        >
          حذف آگهی
        </button>
      </div>
    </div>
  );
};

export default EndTimeWarning;
